module.exports = __webpack_public_path__ + "img/logo.dc0a6448.svg";